// マスク画面
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Heading from '../../molecules/Heading';
import TransitionButton from '../../molecules/TransitionButton';
import Canvas from '../../molecules/Canvas';
import { pos_x, scroll_amount, timer_interval } from '../../const/MaskImage';
import { ShelfInfo, SetShelfInfo, ShelfInfoObj } from '../../types/FileUpload';
import { init_shelfs } from '../../const/FileUpload';
import { releaseBrowserBack, banBrowserBack } from '../../BrowserBack';
import TopHeading from '../../molecules/TopHeading';
import { toBlob } from '../../Common';

// ロングタップ中のタイマーを格納するための変数を定義
let timer: NodeJS.Timeout;

interface Props {
  shelf_info: ShelfInfoObj;
  setShelfInfo: SetShelfInfo;
}

const MaskImage: React.FC<Props> = ({ shelf_info, setShelfInfo }) => {
  const { shelf_cd, target_index } = useParams<{ shelf_cd: string; target_index: string }>();
  const history = useHistory();

  /**
   * 前画面に遷移
   */
  const hideMask = () => {
    releaseBrowserBack();
    history.goBack();
    banBrowserBack();
  };

  /**
   * 表示対象となる画像を取得する
   *
   * @return {*}  {ShelfInfo}
   */
  const getTargetImage = (): ShelfInfo => {
    switch (shelf_cd) {
      case 'A':
        return shelf_info.shelf_info_a;
      case 'B':
        return shelf_info.shelf_info_b;
      case 'C':
        return shelf_info.shelf_info_c;
      case 'D':
        return shelf_info.shelf_info_d;
      case 'E':
        return shelf_info.shelf_info_e;
      case 'F':
        return shelf_info.shelf_info_f;
      case 'G':
        return shelf_info.shelf_info_g;
      case 'H':
        return shelf_info.shelf_info_h;
      case 'I':
        return shelf_info.shelf_info_i;
      case 'J':
        return shelf_info.shelf_info_j;
      case 'K':
        return shelf_info.shelf_info_k;
      case 'AA':
        return shelf_info.shelf_info_aa;
      case 'AB':
        return shelf_info.shelf_info_ab;
      case 'AC':
        return shelf_info.shelf_info_ac;
      case 'AD':
        return shelf_info.shelf_info_ad;
      case 'AE':
        return shelf_info.shelf_info_ae;
      case 'AF':
        return shelf_info.shelf_info_af;
      case 'AG':
        return shelf_info.shelf_info_ag;
      case 'AH':
        return shelf_info.shelf_info_ah;
      case 'AI':
        return shelf_info.shelf_info_ai;
      case 'AJ':
        return shelf_info.shelf_info_aj;
      case 'AK':
        return shelf_info.shelf_info_ak;
      case 'AL':
        return shelf_info.shelf_info_al;
      case 'AM':
        return shelf_info.shelf_info_am;
      case 'AN':
        return shelf_info.shelf_info_an;
      case 'AO':
        return shelf_info.shelf_info_ao;
      case 'AP':
        return shelf_info.shelf_info_ap;
      case 'AQ':
        return shelf_info.shelf_info_aq;
      case 'AR':
        return shelf_info.shelf_info_ar;
      case 'AS':
        return shelf_info.shelf_info_as;
      case 'AT':
        return shelf_info.shelf_info_at;
      case 'AU':
        return shelf_info.shelf_info_au;
      case 'AV':
        return shelf_info.shelf_info_av;
      case 'AW':
        return shelf_info.shelf_info_aw;
      case 'AX':
        return shelf_info.shelf_info_ax;
      case 'AY':
        return shelf_info.shelf_info_ay;
      case 'AZ':
        return shelf_info.shelf_info_az;
      case 'BA':
        return shelf_info.shelf_info_ba;
      case 'BB':
        return shelf_info.shelf_info_bb;
      case 'BC':
        return shelf_info.shelf_info_bc;
      case 'BD':
        return shelf_info.shelf_info_bd;
      case 'BE':
        return shelf_info.shelf_info_be;
      case 'BF':
        return shelf_info.shelf_info_bf;
      case 'BG':
        return shelf_info.shelf_info_bg;
      case 'BH':
        return shelf_info.shelf_info_bh;
      case 'BI':
        return shelf_info.shelf_info_bi;
      default:
        return init_shelfs;
    }
  };

  /**
   * マスク済み画像を適用する
   *
   * @param {string} image_file マスク済みイメージ
   */
  const handleFinish = (image_file: string) => {
    switch (shelf_cd) {
      case 'A':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoA);
        break;
      case 'B':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoB);
        break;
      case 'C':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoC);
        break;
      case 'D':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoD);
        break;
      case 'E':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoE);
        break;
      case 'F':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoF);
        break;
      case 'G':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoG);
        break;
      case 'H':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoH);
        break;
      case 'I':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoI);
        break;
      case 'J':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoJ);
        break;
      case 'K':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoK);
        break;
      case 'AA':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAA);
        break;
      case 'AB':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAB);
        break;
      case 'AC':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAC);
        break;
      case 'AD':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAD);
        break;
      case 'AE':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAE);
        break;
      case 'AF':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAF);
        break;
      case 'AG':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAG);
        break;
      case 'AH':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAH);
        break;
      case 'AI':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAI);
        break;
      case 'AJ':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAJ);
        break;
      case 'AK':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAK);
        break;
      case 'AL':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAL);
        break;
      case 'AM':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAM);
        break;
      case 'AN':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAN);
        break;
      case 'AO':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAO);
        break;
      case 'AP':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAP);
        break;
      case 'AQ':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAQ);
        break;
      case 'AR':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAR);
        break;
      case 'AS':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAS);
      case 'AT':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAT);
        break;
      case 'AU':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAU);
        break;
      case 'AV':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAV);
        break;
      case 'AW':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAW);
        break;
      case 'AX':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAX);
        break;
      case 'AY':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAY);
        break;
      case 'AZ':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoAZ);
        break;
      case 'BA':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoBA);
        break;
      case 'BB':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoBB);
        break;
      case 'BC':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoBC);
        break;
      case 'BD':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoBD);
        break;
      case 'BE':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoBE);
        break;
      case 'BF':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoBF);
        break;
      case 'BG':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoBG);
        break;
      case 'BH':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoBH);
        break;
      case 'BI':
        setMaskedImage(image_file, setShelfInfo.setShelfInfoBI);
        break;
      default:
        break;
    }
  };

  // 登録ボタンのアクション
  const setMaskedImage = (
    image_file: string,
    setShelfInfo: React.Dispatch<React.SetStateAction<ShelfInfo>>
  ) => {
    setShelfInfo(prev => {
      const num_target_index = Number(target_index);
      const new_file_data = prev.file_data.slice();
      new_file_data[num_target_index].file.img = image_file;
      new_file_data[num_target_index].file.file_body = toBlob(
        image_file,
        new_file_data[num_target_index].file.mime
      );
      return { ...prev, file_data: new_file_data };
    });
    hideMask();
  };

  // 画面コントローラー：上方向移動・開始
  const controllerUpStart = () => {
    scrollUp();

    // ロングタップ時の継続スクロール処理
    timer = setInterval(() => {
      scrollUp();
    }, timer_interval);
  };

  // 画面コントローラー：上方向移動・停止
  const controllerUpStop = () => {
    clearInterval(timer);
  };

  // 画面コントローラー：下方向移動・開始
  const controllerDownStart = () => {
    scrollDown();

    timer = setInterval(() => {
      scrollDown();
    }, timer_interval);
  };

  // 画面コントローラー：下方向移動・停止
  const controllerDownStop = () => {
    clearInterval(timer);
  };

  // 上方向スクロール
  const scrollUp = () => {
    const pos_y = window.pageYOffset;
    window.scrollTo(pos_x, pos_y - scroll_amount);
  };

  // 下方向スクロール
  const scrollDown = () => {
    const pos_y = window.pageYOffset;
    window.scrollTo(pos_x, pos_y + scroll_amount);
  };

  return (
    <div className="mask-image">
      <TopHeading label="マスク編集" />

      <div className="container">
        <div className="container-box">
          <Heading label="マスク編集" size="m" />

          <Canvas
            img_src={getTargetImage().file_data[Number(target_index)].file.img}
            disabled={false}
            handleFinish={(image_file: string) => handleFinish(image_file)}
            file_download=""
            file_name={getTargetImage().file_data[Number(target_index)].file.file_name}
            is_pdf={false}
          />

          <TransitionButton label="戻る" handleClick={hideMask} />
        </div>
      </div>

      <div className="controller-up">
        <div onTouchStart={controllerUpStart} onTouchEnd={controllerUpStop}>
          <span>↑</span>
        </div>
      </div>
      <div className="controller-down">
        <div onTouchStart={controllerDownStart} onTouchEnd={controllerDownStop}>
          <span>↓</span>
        </div>
      </div>
    </div>
  );
};

export default MaskImage;
